import styles from '@components/InputBottomDescription/InputBottomDescription.styles';
type PropsType = {
  description: string;
  length: number;
  maxLength: number;
};
const InputBottomDescription = ({
  description,
  length,
  maxLength
}: PropsType) => <div sx={styles.inputDesriptionContainer} data-testid="input-bottom-description">
    <p className="caption" data-testid="input-bottom-description-text">
      {description}
    </p>
    <p className="caption" data-testid="input-bottom-description-counter">
      {length}/{maxLength}
    </p>
  </div>;
export default InputBottomDescription;